import { render } from 'lit-html';
import state from "../state";
import { metaIntroTemplate } from "./templates/meta-intro";
import { metaEntryTemplate } from "./templates/meta-entry";

class MetadataView {
  constructor() {
    this.dom = document.querySelector("#metadata");

    state.channel.subscribe("onGraphLoaded", graph => {
      this.graph = graph;
    });

    state.channel.subscribe("onEntrySelected", entryId => {
      const entry = this.graph.entry(entryId);
      const context = {
        entry,
        onCloseEntry: () => state.channel.publish("onEntryClosed")
      }
      render(metaEntryTemplate(context), this.dom);
    });

    state.channel.subscribe("onEntryClosed", () => {
      this.renderIntro();
    });

    this.renderIntro();
  }

  renderIntro() {
    render(metaIntroTemplate(), this.dom);
  }
}

export default MetadataView;
